var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3843 17.045C39.0956 17.27 33.9986 20.155 33.9986 26.57C33.9986 33.99 40.4843 36.615 40.6785 36.68C40.6486 36.84 39.6481 40.275 37.2589 43.775C35.1285 46.855 32.9035 49.93 29.5188 49.93C26.1341 49.93 25.263 47.955 21.3556 47.955C17.5478 47.955 16.1939 49.995 13.0979 49.995C10.0018 49.995 7.84158 47.145 5.35779 43.645C2.48077 39.535 0.15625 33.15 0.15625 27.09C0.15625 17.37 6.44787 12.215 12.6399 12.215C15.9301 12.215 18.6727 14.385 20.7384 14.385C22.7045 14.385 25.7707 12.085 29.5138 12.085C30.9324 12.085 36.0294 12.215 39.3843 17.045ZM27.7368 7.97C29.2849 6.125 30.3799 3.565 30.3799 1.005C30.3799 0.65 30.3501 0.29 30.2853 0C27.7667 0.095 24.7702 1.685 22.9634 3.79C21.5448 5.41 20.2207 7.97 20.2207 10.565C20.2207 10.955 20.2855 11.345 20.3153 11.47C20.4746 11.5 20.7334 11.535 20.9923 11.535C23.2521 11.535 26.0943 10.015 27.7368 7.97Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5172,
    height: 50,
    fill: "white",
    transform: "translate(0.15625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e3f068235cf23e8fd19a4595f132b10e.svg";
export { ForwardRef as ReactComponent };